<script lang="ts" setup>
const localePath = useLocalePath()

const { data } = defineProps<{
  data: ProgressionData
}>()
</script>

<template>
  <div class="flex flex-col gap-4">
    <UiAlert
      v-if="data.challenges.length === 0"
      :title="$t('No challenges found, level up first to reach the next milestone rank')"
      :description="$t('Complete practice games to gain experience points and level up!')"
    />
    <UiAlert
      v-else-if="data.challenges.length > 0"
      variant="info"
      :title="$t('You have {count} challenges to complete', { count: data.challenges.length })"
      :description="$t('Both challenges need to be completed. When you fail a challenge, you loose some experience points and need to play practice games to regain them.')"
    />
    <UiList v-if="data.challenges.length > 0">
      <UiListItem
        v-for="challenge in data.challenges"
        :key="challenge.id"
        :to="challenge.completed_at ? '#' : (challenge.type === 'PLAY_VS_BOT' ? localePath(`/play/bot/${challenge.game_resource?.id}`) : localePath(`/play/training/game/${challenge.id}`))"
      >
        <UiAvatar>
          <NuxtImg
            :src="challenge.type_details.image"
            class="size-10"
          />
        </UiAvatar>
        <UiListContent>
          <UiListTitle :title="challenge.type_details.name" />
          <UiListSubtitle :subtitle="$t('Complete a game:')" />
          <TrainingConfigInfo :game-info="challenge" />
        </UiListContent>
        <UiButton
          v-if="!challenge.completed_at"
          icon="tabler-play"
          size="sm"
          :text="challenge.started_at ? $t('Resume challenge') : $t('Start challenge')"
        />
        <UiBadge
          v-else
          variant="success"
        >
          {{ $t('Completed!') }}
        </UiBadge>
      </UiListItem>
    </UiList>
  </div>
</template>
